import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { NAME_SPACE } from 'i18n';
import { SelectInput, MIME_FILTERS } from 'shared';

export function AudioTagSelect({ options = [], withAnyLabel, ...props }) {
  const { t } = useTranslation(NAME_SPACE.COMMON);

  const elements = useMemo(() => {
    let el = [];
    if (withAnyLabel) el.push({ value: '', name: t('selectFirstOption') });

    el = el.concat(
      options
        .filter(mf => mf.tag && mf.mimeType.startsWith(MIME_FILTERS.AUDIO))
        .map(image => ({ value: image.tag, name: image.tag }))
        .sort((a, b) => (a.value > b.value ? 1 : -1))
    );

    return el;
  }, [t, withAnyLabel, options]);

  return <SelectInput elements={elements} {...props} />;
}

AudioTagSelect.propTypes = {
  value: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
  withAnyLabel: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string
};
